export default "__VITE_ASSET__6a390014__"